import { FormSection } from "components/MainSectionTemplate/types";
import moment from "moment";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

export const recordInformation = (createdUtc: Date,
  createdBy: server.dto.UserSmall,
  lastModifiedUtc: Date,
  lastModifiedBy: server.dto.UserSmall,
  systemOneId?: number): FormSection => {
  return {
    type: "collapsable",
    key: "companyRecordInformationSection",
    title: RESX.RecordInformation.resxRecordInformation,
    fields: [{
      key: "createdOn",
      label: RESX.RecordInformation.CreatedOn,
      render: () => <div>
        {formatWrittenDayMonthYear(moment.utc(createdUtc))} {formatTime(moment.utc(createdUtc))} UTC
        <div className="text-sublabel">
          {RESX.RecordInformation.by} {createdBy.fullName}
        </div>
      </div>,
    }, {
      key: "lastModifiedOn",
      label: RESX.RecordInformation.LastModifiedOn,
      render: () => <div>
        {formatWrittenDayMonthYear(moment.utc(lastModifiedUtc))} {formatTime(moment.utc(lastModifiedUtc))} UTC
        <div className="text-sublabel">
          {RESX.RecordInformation.by} {lastModifiedBy.fullName}
        </div>
      </div>,
    }, {
      key: "systemOneId",
      label: "SystemOne id",
      render: () => <div>{systemOneId}</div>,
      hidden: !systemOneId,
    }]
  }
};